var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgTamanhoM3 = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M55.946 48.236h11.636M61.764 47.496v-3.49"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M86.089 11H36.275C35.57 11 35 11.617 35 12.378v29.826c0 .761.57 1.378 1.275 1.378h49.814c.704 0 1.275-.617 1.275-1.378V12.378c0-.761-.571-1.378-1.275-1.378Z"
  }), React.createElement("path", {
    fill: color,
    d: "M86.089 37.764H46.75v5.818h38.751c.704 0 1.863-1.94 1.863-.646v-4.844c0-.328 0-.328-1.275-.328Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-90)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m52.455 32.012 20.396-8.777M53.057 26.161l13.197-5.851"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M35 35.5V12.378c0-.761.57-1.378 1.275-1.378h49.814c.704 0 1.275.617 1.275 1.378v29.826c0 .761-.571 1.378-1.275 1.378H47.5"
  }), React.createElement("circle", {
    cx: 61.764,
    cy: 40.091,
    r: 1.164,
    fill: "var(--color-neutral-70)"
  }), React.createElement("path", {
    fill: color,
    d: "M18.526 76.136H10.29c-1.86 0-3.372-1.533-3.372-3.42V54.723c0-1.887 1.512-3.42 3.372-3.42h42.208c1.86 0 3.372 1.533 3.372 3.42V72.71c0 1.887-1.511 3.42-3.372 3.42h-8.236"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M18.526 76.136H10.29c-1.86 0-3.372-1.533-3.372-3.42V54.723c0-1.887 1.512-3.42 3.372-3.42h42.208c1.86 0 3.372 1.533 3.372 3.42V72.71c0 1.887-1.511 3.42-3.372 3.42h-8.236"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M43.797 69.767H18.985a.462.462 0 0 0-.459.465v13.074c0 .258.206.466.46.466h24.811a.462.462 0 0 0 .46-.466V70.232a.462.462 0 0 0-.46-.465Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M18.825 50.537V38.583c0-.242.207-.443.47-.443h24.71c.256 0 .47.195.47.443v11.954"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M18.825 50.537V38.583c0-.242.207-.443.47-.443h24.71c.256 0 .47.195.47.443v11.954"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M13.82 57.034h35.147M40.806 62.763h2.515M46.46 62.763h2.508"
  }), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M18.843 51.302h-5.005l-.018-3.104c0-1.099.875-1.992 1.964-1.992h3.06"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M18.843 51.302v-5.096h-3.059c-1.09 0-1.964.893-1.964 1.992l.018 3.104h5.005Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-90)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M23.237 74.224H39.55M23.237 78.048h10.666"
  }), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M45.04 51.275h4.552v-3.077c0-1.099-.876-1.992-1.965-1.992H45.04"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M45.04 51.275h4.552v-3.077c0-1.099-.876-1.992-1.965-1.992H45.04"
  }));
};
export default SvgTamanhoM3;